
define('text!areas/logout/views/index.html',[],function () { return '<div>\r\n</div>';});

